import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { postRequest ,getRequest} from "../api/api"; 
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";
import "./login.css";



const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ✅ Check token + expiry on app load
  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiry = localStorage.getItem("expiry");

    if (token && expiry) {
      const now = Date.now();
      if (now > parseInt(expiry, 10)) {
        // Expired → clear storage and redirect
        localStorage.clear();
        navigate("/");
      } else {
        navigate("/dashboard");
      }
    }
  }, [navigate]);

const onFinish = async (values) => {
  const { email, password } = values;
  setLoading(true);

  try {
    const response = await postRequest("login", { email, password });

    // ✅ Check if role is 'MA'
    if (response.user?.role !== "MA") {
      Swal.fire({
        icon: "error",
        title: "Access Denied",
        text: "You are not authorized to access this Panel.",
      });
      setLoading(false);
      return;
    }

    // ✅ Store token, user, and expiry (12h)
    localStorage.setItem("token", response.access_token);
    localStorage.setItem("login_user", JSON.stringify(response.user));
        // ✅ pull fresh profile from /profile (authoritative)
    const profile = await getRequest("profile");
    localStorage.setItem("user", JSON.stringify(profile?.user || response.user || {}));

    const expiryTime = Date.now() + 12 * 60 * 60 * 1000; // 12 hours in ms
    localStorage.setItem("expiry", expiryTime.toString());

    Swal.fire({
      icon: "success",
      title: "Welcome to the Physio Buzz Admin Dashboard!",
      showConfirmButton: false,
      timer: 1500,
    });

    setTimeout(() => {
      navigate("/dashboard");
    }, 1500);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Login Failed",
      text: "Invalid credentials. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-container">
      {loading && (
        <div className="loader-overlay">
          <Oval
            height={60}
            width={60}
            color="#3b82f6"
            secondaryColor="#cbd5e1"
            strokeWidth={4}
            strokeWidthSecondary={4}
          />
        </div>
      )}

      <div className="login-logo">
        <img src="/physio-logo.png" alt="login visual" />
      </div>

      <div className="login-box">
        <div className="login-image">
          <img src="/login.jpg" alt="login visual" />
        </div>
        <div className="login-form">
          <h2>Sign in</h2>
          <Form
            name="login_form"
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
          >
            <Form.Item
              label="Your Email"
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="name@company.com" />
            </Form.Item>

            <Form.Item
              label="Your Password"
              name="password"
              rules={[{ required: true, message: "Please input your password!" }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="••••••••" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
